import type { CricketTeamPage } from "../types";

const baseCricketTeams: CricketTeamPage[] = [
  {
    slug: "pakistan",
    name: "Pakistan",
    fullName: "Pakistan National Cricket Team",
    shortName: "PAK",
    type: "international",
    testDebut: "1952",
    odiDebut: "1973",
    t20Debut: "2006",
    summary: [
      "Pakistan cricket team pace bowling depth, unpredictable match temperament, aur major ICC peaks ki wajah se world cricket ki sab se high-interest entities mein se aik hai.",
      "Is team layer se users Babar Azam jese key players, Wasim Akram jese legends, India rivalry matches, aur Pakistan-linked records tak directly pohanch sakte hain.",
    ],
    currentPlayers: [
      "babar-azam",
      "mohammad-rizwan",
      "shaheen-shah-afridi",
      "naseem-shah",
      "haris-rauf",
    ],
    famousPlayers: [
      "imran-khan",
      "wasim-akram",
      "waqar-younis",
      "javed-miandad",
    ],
    relatedRecords: [
      "highest-team-score",
      "highest-chase",
      "lowest-team-score",
    ],
    famousMatches: [
      "wc-1992-final",
      "ct-2017-final",
      "t20wc-2022-ind-vs-pak",
      "pakistan-vs-newzealand-1992-semi",
    ],
    rivalTeams: ["india", "australia", "england"],
    comparisonLinks: [
      {
        title: "Pakistan vs India",
        to: "/cricket/matches/india-vs-pakistan/",
        description:
          "Sab se searched cricket rivalry jahan major World Cup aur T20 clashes grouped hain.",
      },
      {
        title: "Pakistan in World Cup Finals",
        to: "/cricket/matches/world-cup-finals/",
        description:
          "Pakistan ke title matches aur knockout moments ko finals cluster ke sath follow karein.",
      },
    ],
    achievements: [
      "1992 Cricket World Cup jeeta",
      "2017 Champions Trophy title ke sath white-ball high point hasil kiya",
    ],
  },
  {
    slug: "india",
    name: "India",
    fullName: "India National Cricket Team",
    shortName: "IND",
    type: "international",
    testDebut: "1932",
    odiDebut: "1974",
    t20Debut: "2006",
    summary: [
      "India cricket team batting depth, tournament reach, aur massive rivalry intent ki wajah se global cricket graph ka central node hai.",
      "Team page se user Virat Kohli, Rohit Sharma, MS Dhoni jese player entities, Pakistan rivalry pages, aur India-linked finals tak fast travel kar sakta hai.",
    ],
    currentPlayers: [
      "virat-kohli",
      "rohit-sharma",
      "jasprit-bumrah",
      "ravindra-jadeja",
      "shubman-gill",
    ],
    famousPlayers: [
      "sachin-tendulkar",
      "ms-dhoni",
      "rahul-dravid",
      "sourav-ganguly",
    ],
    relatedRecords: [
      "highest-team-score",
      "highest-run-chase-odi",
      "highest-partnership",
    ],
    famousMatches: [
      "wc-2011-final",
      "india-vs-southafrica-2024",
      "t20wc-2022-ind-vs-pak",
      "wc-2023-final",
    ],
    rivalTeams: ["pakistan", "australia", "england"],
    comparisonLinks: [
      {
        title: "India vs Pakistan",
        to: "/cricket/matches/india-vs-pakistan/",
        description:
          "India-Pakistan rivalry scorecards aur tournament clashes ko one hub mein dekhain.",
      },
      {
        title: "India in World Cup Finals",
        to: "/cricket/matches/world-cup-finals/",
        description:
          "World Cup final appearances aur title match context India intent ko deeper banata hai.",
      },
    ],
    achievements: [
      "1983 aur 2011 ODI World Cup titles",
      "2007, 2024 aur 2026 T20 World Cup titles se short-format legacy aur strong hui",
      "2025 Champions Trophy title ne recent white-ball success ko aur reinforce kiya",
    ],
  },
  {
    slug: "australia",
    name: "Australia",
    fullName: "Australia National Cricket Team",
    shortName: "AUS",
    type: "international",
    testDebut: "1877",
    odiDebut: "1971",
    t20Debut: "2005",
    summary: [
      "Australia cricket team all-format winning culture, World Cup dominance, aur historic captains ki wajah se cricket history ka backbone side mana jata hai.",
      "Is page par users modern Australian stars se le kar Don Bradman aur Ricky Ponting jese legends, plus famous finals aur chase records tak ja sakte hain.",
    ],
    currentPlayers: [
      "pat-cummins",
      "steve-smith",
      "mitchell-starc",
      "david-warner",
    ],
    famousPlayers: [
      "don-bradman",
      "ricky-ponting",
      "glenn-mcgrath",
      "brett-lee",
    ],
    relatedRecords: [
      "highest-team-score",
      "highest-run-chase-odi",
      "highest-chase",
    ],
    famousMatches: [
      "wc-2003-final",
      "wc-2023-final",
      "australia-vs-southafrica-434-match",
      "australia-vs-india-2020-brisbane",
    ],
    rivalTeams: ["india", "england", "south-africa"],
    comparisonLinks: [
      {
        title: "Ashes and Classic Australia Rivalries",
        to: "/cricket/matches/classic-tests/",
        description:
          "England ke sath Ashes context aur classic Test scorecards Australia journey ka core hissa hain.",
      },
      {
        title: "Australia Great Chases",
        to: "/cricket/matches/great-chases/",
        description:
          "Australia se linked 434-game aur high-pressure chase classics yahan grouped hain.",
      },
    ],
    achievements: [
      "ODI World Cup mein sab se successful side",
      "Test cricket history ke strongest eras mein se kai Australia ne define kiye",
    ],
  },
  {
    slug: "england",
    name: "England",
    fullName: "England Cricket Team",
    shortName: "ENG",
    type: "international",
    testDebut: "1877",
    odiDebut: "1971",
    t20Debut: "2005",
    summary: [
      "England cricket team red-ball history, modern white-ball transformation, aur Lord's-era iconic matches ki wajah se high-value entity page hai.",
      "Team hub se users Ben Stokes, Joe Root, Jos Buttler, 2019 final, aur Ashes-style match clusters tak connected rehte hain.",
    ],
    currentPlayers: ["joe-root", "ben-stokes", "jos-buttler", "jofra-archer"],
    famousPlayers: ["alastair-cook", "kevin-pietersen", "ben-stokes"],
    relatedRecords: [
      "highest-team-score",
      "highest-chase",
      "highest-run-chase-odi",
    ],
    famousMatches: [
      "wc-2019-final",
      "westindies-vs-england-2016-final",
      "england-vs-india-2022-test",
      "pakistan-vs-england-2010",
    ],
    rivalTeams: ["australia", "india", "new-zealand"],
    comparisonLinks: [
      {
        title: "England Classic Tests",
        to: "/cricket/matches/classic-tests/",
        description:
          "Ashes aur red-ball England matches ko deeper rivalry context ke sath dekhein.",
      },
      {
        title: "England in Major Finals",
        to: "/cricket/matches/recent-finals/",
        description:
          "Recent white-ball finals aur title runs England ka modern identity layer complete karte hain.",
      },
    ],
    achievements: [
      "2019 ODI World Cup title",
      "2022 T20 World Cup title ke sath dual white-ball era complete hua",
    ],
  },
  {
    slug: "south-africa",
    name: "South Africa",
    fullName: "South Africa National Cricket Team",
    shortName: "SA",
    type: "international",
    captain: "Temba Bavuma",
    coach: "Rob Walter",
    testDebut: "1889",
    odiDebut: "1991",
    t20Debut: "2005",
    summary: [
      "South Africa cricket team fast bowling quality, elite fielding standards, aur dramatic ODI storylines ki wajah se cricket graph mein bohat strong entity hai.",
      "AB de Villiers, Jacques Kallis, Kagiso Rabada aur 434 chase jese touchpoints is side ko records aur match history ke sath tightly connect karte hain.",
    ],
    currentPlayers: ["kagiso-rabada", "quinton-de-kock"],
    famousPlayers: [
      "ab-de-villiers",
      "jacques-kallis",
      "graeme-smith",
      "herschelle-gibbs",
    ],
    relatedRecords: [
      "highest-run-chase-odi",
      "highest-team-score",
      "highest-chase",
    ],
    famousMatches: ["australia-vs-southafrica-434-match", "south-africa-vs-australia-2025-wtc-final", "india-vs-southafrica-2024"],
    rivalTeams: ["australia", "india", "england"],
    comparisonLinks: [
      {
        title: "South Africa Great Chases",
        to: "/cricket/matches/great-chases/",
        description:
          "434 chase aur other high-scoring match paths South Africa intent ko instantly satisfy karte hain.",
      },
    ],
    achievements: [
      "1990s ke baad se world cricket ki most consistent competitive teams mein shamil",
      "2025 World Test Championship jeet kar major ICC title drought khatam ki",
    ],
  },
  {
    slug: "new-zealand",
    name: "New Zealand",
    fullName: "New Zealand National Cricket Team",
    shortName: "NZ",
    type: "international",
    testDebut: "1930",
    odiDebut: "1973",
    t20Debut: "2005",
    summary: [
      "New Zealand cricket team calm tournament identity, balanced combinations, aur 2019 final jese iconic matches ki wajah se strong discovery entity hai.",
      "Kane Williamson-led narratives users ko player pages, finals, aur white-ball match classics ke sath naturally jorte hain.",
    ],
    currentPlayers: ["kane-williamson", "trent-boult", "tim-southee"],
    famousPlayers: ["ross-taylor", "martin-guptill", "daniel-vettori"],
    relatedRecords: [
      "highest-team-score",
      "highest-chase",
      "highest-run-chase-odi",
    ],
    famousMatches: [
      "wc-2019-final",
      "pakistan-vs-newzealand-1992-semi",
    ],
    rivalTeams: ["england", "australia", "pakistan"],
    comparisonLinks: [
      {
        title: "New Zealand Finals And Knockouts",
        to: "/cricket/matches/world-cup-finals/",
        description:
          "New Zealand ke biggest finals aur knockout scorecards ko direct follow karein.",
      },
    ],
    achievements: [
      "Recent ICC cycles mein sab se stable tournament sides mein shamil",
    ],
  },
  {
    slug: "sri-lanka",
    name: "Sri Lanka",
    fullName: "Sri Lanka National Cricket Team",
    shortName: "SL",
    type: "international",
    testDebut: "1982",
    odiDebut: "1975",
    t20Debut: "2006",
    summary: [
      "Sri Lanka cricket team 1996 World Cup legacy, unorthodox stars, aur spin-plus-skill identity ki wajah se all-time important side hai.",
      "Muralitharan, Sangakkara, Jayasuriya aur Lasith Malinga users ko records, legends, aur finals history ke multiple pathways dete hain.",
    ],
    currentPlayers: [],
    famousPlayers: [
      "muttiah-muralitharan",
      "kumar-sangakkara",
      "sanath-jayasuriya",
      "lasith-malinga",
    ],
    relatedRecords: [
      "highest-team-score",
      "lowest-team-score",
      "highest-partnership",
    ],
    famousMatches: ["wc-2011-final", "pakistan-vs-srilanka-2009"],
    rivalTeams: ["india", "pakistan", "australia"],
    comparisonLinks: [
      {
        title: "Sri Lanka In Historic Finals",
        to: "/cricket/matches/world-cup-finals/",
        description:
          "World Cup final history aur major subcontinent clashes Sri Lanka intent ko extend karte hain.",
      },
    ],
    achievements: [
      "1996 ODI World Cup title Sri Lanka history ka defining tournament peak hai",
    ],
  },
  {
    slug: "west-indies",
    name: "West Indies",
    fullName: "West Indies Cricket Team",
    shortName: "WI",
    type: "international",
    testDebut: "1928",
    odiDebut: "1973",
    t20Debut: "2006",
    summary: [
      "West Indies cricket team power-hitting, fast bowling history, aur 1970s-80s dominance ki wajah se cricket legacy graph ka giant node hai.",
      "Brian Lara, Chris Gayle aur major finals users ko batting legends, T20 peaks, aur classic match pages tak le jate hain.",
    ],
    currentPlayers: ["andre-russell"],
    famousPlayers: ["brian-lara", "chris-gayle", "shivnarine-chanderpaul"],
    relatedRecords: [
      "highest-team-score",
      "highest-chase",
      "lowest-team-score",
    ],
    famousMatches: [
      "westindies-vs-england-2016-final",
      "pakistan-vs-westindies-1987",
    ],
    rivalTeams: ["england", "australia", "pakistan"],
    comparisonLinks: [
      {
        title: "West Indies Big Finals",
        to: "/cricket/matches/recent-finals/",
        description:
          "T20 final success aur older global clashes ko finals clusters ke through follow karein.",
      },
    ],
    achievements: [
      "Back-to-back ODI World Cup titles ke sath early world cricket dominance establish ki",
    ],
  },
  {
    slug: "bangladesh",
    name: "Bangladesh",
    fullName: "Bangladesh National Cricket Team",
    shortName: "BAN",
    type: "international",
    testDebut: "2000",
    odiDebut: "1986",
    t20Debut: "2006",
    summary: [
      "Bangladesh cricket team modern subcontinent growth story aur ODI upset potential ki wajah se team graph mein important developing node hai.",
      "Current dataset mein Bangladesh player coverage abhi lighter hai, lekin team page phir bhi records, tournaments, aur neighbouring rivalries ke sath intent ko capture karta hai.",
    ],
    currentPlayers: [],
    famousPlayers: [],
    relatedRecords: [
      "highest-team-score",
      "lowest-team-score-odi",
      "highest-chase",
    ],
    famousMatches: [],
    rivalTeams: ["india", "pakistan", "sri-lanka"],
    comparisonLinks: [
      {
        title: "Bangladesh And Asian Tournament Context",
        to: "/cricket/tournaments/asia-cup/",
        description:
          "Regional competition pages Bangladesh team intent ko broader Asian rivalry context deti hain.",
      },
    ],
    achievements: [
      "White-ball cricket mein upset wins aur tournament progress ne Bangladesh ko stronger modern side banaya",
    ],
  },
  {
    slug: "afghanistan",
    name: "Afghanistan",
    fullName: "Afghanistan National Cricket Team",
    shortName: "AFG",
    type: "international",
    testDebut: "2018",
    odiDebut: "2009",
    t20Debut: "2010",
    summary: [
      "Afghanistan cricket team fast growth, spin identity, aur recent global tournament relevance ki wajah se one of the most interesting emerging entities hai.",
      "Rashid Khan aur Mohammad Nabi jese names team page ko player graph ke sath connect karte hain, jab ke tournaments aur records side ko broader context dete hain.",
    ],
    currentPlayers: ["rashid-khan", "hashmatullah-shahidi"],
    famousPlayers: ["mohammad-nabi", "rashid-khan"],
    relatedRecords: [
      "highest-team-score",
      "lowest-team-score-t20",
      "highest-chase",
    ],
    famousMatches: [],
    rivalTeams: ["pakistan", "india", "bangladesh"],
    comparisonLinks: [
      {
        title: "Afghanistan In Modern Tournaments",
        to: "/cricket/tournaments/t20-world-cup/",
        description:
          "Tournament pages Afghanistan ke rapid rise ko broader event context ke sath explain karte hain.",
      },
    ],
    achievements: [
      "Associate se full-member journey ne Afghanistan ko modern cricket growth story ka standout example banaya",
    ],
  },
];

function withEnglishTeamCopy(team: CricketTeamPage): CricketTeamPage {
  const playerCount = team.currentPlayers.length + team.famousPlayers.length

  return {
    ...team,
    summary: [
      `${team.fullName} is a ${team.type} cricket team page focused on players, famous matches, rivalries, and records.`,
      `${team.name} links ${playerCount} player references with team records, match pages, rivalry paths, and comparison routes.`,
    ],
    comparisonLinks: team.comparisonLinks?.map((link) => ({
      ...link,
      description: `${link.title} connects ${team.name} with relevant match, rivalry, and team-history context.`,
    })),
    achievements: team.achievements?.map((_, index) =>
      index === 0
        ? `${team.name} has major cricket achievements covered through this team hub.`
        : `${team.name} achievement context is linked with players, matches, tournaments, and records.`,
    ),
  }
}

export const cricketTeams: CricketTeamPage[] = baseCricketTeams.map(withEnglishTeamCopy);





